
import Form from "./Form.vue";

export default {
  name: "app-banco-create",
  components: {
    Form,
  },
  mounted() {},
};
